import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchBookDetail, type BookDetail } from "./api";
import { formatBRL } from "../../lib/currency";
import { useCart } from "../../lib/cart-context";

export function BookDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const [book, setBook] = useState<BookDetail | null>(null);
  const [status, setStatus] = useState<"idle" | "loading" | "adding" | "error">("loading");
  const { addItem } = useCart();

  useEffect(() => {
    if (!slug) return;
    setStatus("loading");
    fetchBookDetail(slug)
      .then((data) => {
        setBook(data);
        setStatus("idle");
      })
      .catch(() => setStatus("error"));
  }, [slug]);

  if (status === "loading") return <p className="text-muted">Carregando…</p>;
  if (status === "error" || !book) return <p className="empty-state">Livro não encontrado.</p>;

  return (
    <article className="book-detail">
      <div className="book-card__cover">
        {book.coverUrl ? (
          <img src={book.coverUrl} alt={`Capa de ${book.title}`} />
        ) : (
          <span className="book-card__cover-fallback" aria-hidden="true">
            {book.title.charAt(0)}
          </span>
        )}
      </div>
      <div>
        <h1>{book.title}</h1>
        {book.subtitle && <p className="text-muted">{book.subtitle}</p>}
        {book.authors.length > 0 && <p className="book-detail__authors">{book.authors.map((a) => a.name).join(" · ")}</p>}

        <p className="price-tag">{book.isFree ? "Gratuito" : book.priceCents != null ? formatBRL(book.priceCents) : "—"}</p>

        <div className="format-tags">
          {(book.formats.length ? book.formats : ["—"]).map((format) => (
            <span key={format} className="format-tag">
              {format}
            </span>
          ))}
        </div>

        <div className="book-detail__actions">
          <button
            className="btn"
            disabled={status === "adding"}
            onClick={async () => {
              setStatus("adding");
              await addItem(book.id, 1);
              setStatus("idle");
            }}
          >
            {status === "adding" ? "Adicionando…" : "Adicionar ao carrinho"}
          </button>
          {book.hasPreview && (
            <a className="btn btn-secondary" href={`/api/public/preview/${book.id}`} target="_blank" rel="noreferrer">
              Ver amostra (10 páginas)
            </a>
          )}
        </div>

        <p>{book.description}</p>
      </div>
    </article>
  );
}
